import { z } from 'zod'

export const csvImportSourceEnum = z.enum(['goodreads', 'storygraph', 'auto'])
export type CsvImportSource = z.infer<typeof csvImportSourceEnum>

export type ImportRowStatus = 'imported' | 'skipped' | 'failed'

export interface ImportRowResult {
  row: number
  title: string
  author: string
  status: ImportRowStatus
  reason?: string
}

export interface JournalImportResult {
  source: CsvImportSource
  totalRows: number
  imported: number
  skipped: number
  failed: number
  results: ImportRowResult[]
}
